<template>
    
    <div class="search-bottom-container">
        <SBTable />
    </div>
</template>

<script>

    import SBTable from "@/components/SBTable";

    export default {
        name: "SearchBottom",
        components: {
            SBTable
        }  
    };
</script>